const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        "label": '대상연월',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: '',
          useAllYear: true,
        }
      },
      {
        'component': 'search-month',
        "label": '월',
        "value": 'month',
        "query": {'y_m': 'month'},
        "options": {
          default: '',
          lastLabel: true,
          useAllMonth: true,
        }
      },
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['Head 3']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // // 검색연도
    if (search.year) {
      conditions.push({key: 'body.headerYear', operator: 'LIKE', value: search.year})
    }
    if (search.month) {
      const month = typeof search.month === 'string' ? parseInt(search.month) : search.month;
      conditions.push({key: 'body.headerMonth', operator: 'LIKE', value: month >= 10 ? month : `0${  month}`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": '학교명',
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업공정명",
        "key": "body.msdsProcesss[%]"
      },
      {
        "name": "물질명",
        "key": "body.msdsMaterials[%]"
      },
      {
        "name": "대상연월",
        "key": "body.headerDate"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContentStringList(func.getContent(value).msdsProcesss) // 작업공정명
      case 2: return func.getContentStringList(func.getContent(value).msdsMaterials) // 물질명
      case 3: return func.getContent(value).headerDateString // 대상연월
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
